import { createSelector } from 'reselect';

import { mountSelectorAt } from 'utils/selectors';

const mount = mountSelectorAt('goals');

export const getGoalsById = mount(localState => localState.byId);

export const getGoals = createSelector(
  getGoalsById,
  goalsById => Object.keys(goalsById).map(key => goalsById[key])
);

export const getGoal = mount((localState, id) => localState.byId[id]);

export const getGoalAdding = mount(localState => localState.goalAdding);

export const getGoalsFetching = mount(localState => localState.goalsFetching);



/** WEBPACK FOOTER **
 ** ./src/members/state/goals/selectors.js
 **/